import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useGetLoggedInUser = () => {
  const user = useSelector((state) => state.AuthReducer.userLogindata?.data);
  return user;
};

const useCheckRole = () => {
  const user = useSelector((state) => state.AuthReducer.userLogindata?.data);
  const checkRole=(irole)=>{
    switch(irole){
      case 'maindoctor':
        return (user?.role === 'MainDoctor')
      case 'consultant':
        return (user?.role === 'Consultant')
    }
  }
  
  return checkRole
};

/**
 * Contact-form defaults for the signed-in user. The login payload carries one
 * `name`, so the first word becomes the first name and the rest the last name.
 */
const useSignedInContactDetails = () => {
  const user = useGetLoggedInUser();

  return useMemo(() => {
    const [firstname = '', ...rest] = String(user?.name || '').trim().split(/\s+/);
    return {
      firstname,
      lastname: rest.join(' '),
      email: user?.email || '',
      mobileNo: user?.phone || '',
    };
  }, [user?.name, user?.email, user?.phone]);
};

export {useGetLoggedInUser, useCheckRole, useSignedInContactDetails}